<template>
  <div class="">
    <AppDataProperty
      contentId="platformSubscriptions"
      @dataAvailable="
        data => {
          if (!data?.metaData?.subscriptions) return
          options = data?.metaData?.subscriptions
        }
      "
      isComponent
    />
    <div class="hidden">
      <SubscriptionSelector ref="subscriptionSelector" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import SubscriptionSelector from './SubscriptionSelector.vue'
import AppDataProperty from '@/components/appData/AppDataProperty.vue'

export default defineComponent({
  name: 'SubscriptionRelauncher',
  components: {
    SubscriptionSelector,
    AppDataProperty,
  },
  props: {},
  data() {
    return {
      options: [],
    }
  },
  mounted() {},
  methods: {
    relaunchSubscription(transaction) {
      console.log(transaction)
      const platformId =
        transaction?.metaData?.dst?.metadata?.subscription?.metadata?.platformId
      let option = this.options.find(opt => opt.platformId == platformId)
      option = this.$refs.subscriptionSelector.selectOptionAndConfig(option)
      console.log(option)
      const formData = {
        duration: transaction?.metaData?.dst?.metadata?.duration,
        recipientEmail: transaction?.metaData?.dst?.metadata?.recipientEmail,
      }
      this.$Events.dispatchEvent('service_launching_prefilled_requested', {
        service: { serviceId: 'subscription' },
        option,
        formData,
      })
    },
  },
})
</script>
